export { default } from './QuestionAnswerList';
export { default as adapter } from './adapter';
